import { useText } from "@/lib/content";
import { useEffect, useRef, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth, homeForRole } from "@/context/AuthContext";
import { Notice } from "@/components/form/FormFeedback";
import { Loading } from "@/components/layout/RequireAuth";
import { usePageTitle } from "@/components/layout/AppLayout";
import { AuthCard, useResend } from "@/pages/Login";

export default function ConfirmEmail() {
    const t = useText();
    usePageTitle("Conferma email");
    const [params] = useSearchParams();
    const token = params.get("token") || "";
    const { user, refresh } = useAuth();
    const [state, setState] = useState("checking");
    const started = useRef(false);
    const { msg, send } = useResend();

    useEffect(() => {
        if (started.current) return;
        started.current = true;
        if (!token) {
            setState("invalid");
            return;
        }
        api.post("/auth/confirm-email", { token })
            .then(() => {
                setState("ok");
                refresh();
            })
            .catch(() => setState("invalid"));
    }, [token, refresh]);

    if (state === "checking") return <Loading label="Verifica del link in corso…" />;
    return (
        <AuthCard title={t("auth.confirm_title")}>
            {state === "ok" ? (
                <div className="space-y-4">
                    <Notice kind="success" testId="confirm-success-message">{t("auth.confirm_success")}</Notice>
                    <Link to={user ? homeForRole(user.role) : "/accedi"} className="btn-primary" data-testid="confirm-continue-link">
                        {user ? "Vai al tuo profilo" : "Accedi"}
                    </Link>
                </div>
            ) : (
                <div className="space-y-4">
                    <Notice kind="error" role="alert" testId="confirm-invalid-message">Link non valido o scaduto</Notice>
                    {user && user.role === "azienda" && !user.email_confirmed ? (
                        <>
                            <button type="button" className="btn-primary" onClick={send} data-testid="confirm-request-new-button">Richiedi un nuovo link</button>
                            <p role="status" aria-live="polite" data-testid="confirm-request-new-status">{msg}</p>
                        </>
                    ) : (
                        <p>
                            Per ricevere un nuovo link <Link to="/accedi" data-testid="confirm-login-link">accedi</Link> e usa il pulsante "Invia di nuovo".
                        </p>
                    )}
                </div>
            )}
        </AuthCard>
    );
}
